import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaDiscord } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Architect of the interface, custodian of your digital experience.
              Bridging technical precision with a bespoke flair for the web, I
              orchestrate the structural framework of the frontend while
              ensuring your pursuit of flawless UI, seamless interactions, and
              pixel-perfect designs remains utterly delightful.
              <br />
              <br />
              A self-taught virtuoso who fell down the tech rabbit hole at 16,
              my journey has been curated through endless late-night debugging
              sessions and an insatiable curiosity for how the digital cosmos is
              stitched together.
              <br />
              <br />I specialize in weaving modern enchantments using
              <i>
                <b className="purple">
                  {" "}
                  HTML, CSS, Tailwind CSS, JavaScript, React.js, Firebase and
                  more...
                </b>
              </i>
              , transforming raw logic into refined, user-friendly web
              applications that feel like a warm hug.
              <br />
              <br />
              Beyond the canvas of web development, my curiosity extends to new
              frontiers. I am increasingly drawn to the mobile realm through
              <i>
                <b className="purple"> Android app development</b>
              </i>
              , and I harbor a profound fascination for the clandestine arts of
              <i>
                <b className="purple"> ethical hacking and cybersecurity</b>
              </i>
              . While I may not be donning a digital trench coat just yet, the
              intricate puzzles of both mobile ecosystems and digital security
              have thoroughly captured my interest.
              <br />
              <br />
              Every skill I possess is a product of artisanal{" "}
              <b className="purple"> self-teaching</b>, relentless dedication,
              and a sprinkle of madness. The code is my canvas, the journey is
              profoundly personal, and trust me — we are merely at the prologue.
              🚀🕸️
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Spidycoder-AS"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/notsp1dy"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://discord.gg/pDZPKud"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaDiscord />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/iftikhar.hssn"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
            <p>
              Feel free to <span className="blue-text">connect </span>with me
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
